import { http } from "./api-config";

const apiClient = http(process.env.VUE_APP_IR_SERVICE);

export default {
  async getStocks() {
    const res = await apiClient.get("hoolders");
    return res.data;
  },
  async getBusinessManagement() {
    const res = await apiClient.get("business-management");
    return res.data;
  },
  async getPowerBIReport() {
    const res = await apiClient.get(`getPowerBiReport`)
    return res.data
  },
  async RefreshPowerBIReport() {
    const res = await apiClient.get(`RefreshPowerBIReport`)
    return res.data
  },
};
